import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { ContentAlignment } from '../types/ContentAlignment';

export function composeContentAlignmentClasses(content: Adaptive<ContentAlignment>): string {
    if (typeof content === 'object') {
        return clsx(
            content.base && `content-${content.base}`,
            content.sm && `sm:content-${content.sm}`,
            content.md && `md:content-${content.md}`,
            content.lg && `lg:content-${content.lg}`,
            content.xl && `xl:content-${content.xl}`,
            content['2xl'] && `2xl:content-${content['2xl']}`
        );
    }

    return `content-${content}`;
}
